module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-video-deea60eb2e77fc4b9e7b7c6484d0287c.svg";